import { NavLink } from "react-router-dom";
import './TempleActivities.css';

const TempleActivities = () => {
    return (
        <section className="yk-ta-section">
            <div className="yk-ta-grid">

                {/* ── Image Column ── */}
                <div className="yk-ta-image-col">
                    <img
                        src="https://stssevastorage.blob.core.windows.net/ykwebsite/resource/featured-image-2.jpg"
                        alt="Spiritual gathering at Yugal Kunj temple"
                    />
                </div>

                {/* ── Content Column ── */}
                <div className="yk-ta-content-col">
                    <div className="yk-ta-content-inner">

                        {/* Ornament */}
                        <div className="yk-ta-ornament">
                            <div className="yk-ta-ornament-line"></div>
                            <div className="yk-ta-ornament-dot"></div>
                            <span className="yk-ta-ornament-label">Yugal Kunj Temple</span>
                        </div>

                        {/* Heading */}
                        <h2 className="yk-ta-heading">Join Temple Activities</h2>

                        {/* Gold divider */}
                        <div className="yk-ta-divider"></div>

                        {/* Description */}
                        <p className="yk-ta-text">
                            The temple have deities of Radha-Krishna and Sita-Ram and is a place of worship that promotes selfless devotion to God. Apart from daily prayers and Artis, the temple aims to have regular satsangs, periodic discourses by preachers of Jagadguru Kripalu Parishat, provide easy access to preacher and priest, literature and devotional media such as books, audio CDs and video DVDs to help individuals and families advance on the spiritual path.
                        </p>

                        {/* CTA */}
                        <NavLink to='/USA/upcomingevents' className="yk-ta-cta">
                            View All Events
                            <span className="yk-ta-cta-arrow">→</span>
                        </NavLink>

                        {/* Trust stats */}
                        <div className="yk-ta-stats">
                            <div className="yk-ta-stat">
                                <span className="yk-ta-stat-value">Daily</span>
                                <span className="yk-ta-stat-label">Prayers & Aarti</span>
                            </div>
                            <div className="yk-ta-stat">
                                <span className="yk-ta-stat-value">Weekly</span>
                                <span className="yk-ta-stat-label">Satsangs</span>
                            </div>
                            <div className="yk-ta-stat">
                                <span className="yk-ta-stat-value">All Ages</span>
                                <span className="yk-ta-stat-label">Classes & Programs</span>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </section>
    );
};

export default TempleActivities;